import "antd/es/badge/style";
import _Badge from "antd/es/badge";
import "antd/es/space/style";
import _Space from "antd/es/space";
import "antd/es/col/style";
import _Col from "antd/es/col";
import "antd/es/row/style";
import _Row from "antd/es/row";
import "antd/es/grid/style";
import _Grid from "antd/es/grid";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect, useMemo, useContext, useRef } from 'react';
import { LocaleContext } from '../locale';
import Modal from '../modal';
import './style/index.less';
import IglooTypography from '../typography';
import invariant from 'invariant';
import classnames from 'classnames';
import UploadPreview from '../upload-preview';
import { isMobileAgent } from '../utils/agent-detect';
import { UploadOutlined, LoadingOutlined, ErrorFilled, ShowOutlined, RefreshOutlined } from 'iglooicon';
import Preview from '../upload-preview/media';
import { classifyType } from '../utils/tools';
import MediaItem from './media';
import FormContext from '../form-context';
var useBreakpoint = _Grid.useBreakpoint;
var prefix = 'igloo-upload-photo';

function ClassifyType(type) {
  if (type.includes('image')) {
    return 'image';
  }

  if (type.includes('video')) {
    return 'video';
  }

  if (type.includes('pdf')) {
    return 'pdf';
  }

  return 'unknown';
}

var getFileType = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(src) {
    var r, contentType;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch(src, {
              cache: 'force-cache'
            });

          case 3:
            r = _context.sent;
            contentType = r.headers.get('content-type');
            return _context.abrupt("return", ClassifyType(contentType));

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", 'unknown');

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));

  return function getFileType(_x) {
    return _ref.apply(this, arguments);
  };
}();

var UploadPhoto = function UploadPhoto(props) {
  var _classnames3, _classnames4;

  var limitNumError = useRef();
  var DomRef = useRef();
  var dataUrlRef = useRef([]);

  var _useContext = useContext(FormContext),
      uploadApi = _useContext.uploadApi;

  invariant(typeof props.handleUpload === 'function' || uploadApi, '"handleUpload" should be a function. Or uploadApi should be set at Form/FreeForm');
  invariant(!uploadApi || props.bizKey, '"bizKey" should be set if Upload is used with uploadApi');
  var value = props.value,
      limit = props.limit,
      limitErrorMessage = props.limitErrorMessage,
      descriptions = props.descriptions,
      buttonText = props.buttonText,
      _props$samples = props.samples,
      samples = _props$samples === void 0 ? [] : _props$samples,
      onChange = props.onChange,
      bizKey = props.bizKey,
      _props$handleUpload = props.handleUpload,
      handleUpload = _props$handleUpload === void 0 ? /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(file) {
      var formData, response, rst;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              formData = new FormData();
              formData.append('file', file);
              formData.append('biz_key', bizKey);
              _context2.next = 5;
              return fetch(uploadApi, {
                method: 'post',
                body: formData
              });

            case 5:
              response = _context2.sent;
              _context2.next = 8;
              return response.json();

            case 8:
              rst = _context2.sent;
              return _context2.abrupt("return", rst.url);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }() : _props$handleUpload,
      setFieldError = props.setFieldError,
      className = props.className,
      id = props.id,
      validateField = props.validateField,
      _props$capture = props.capture,
      capture = _props$capture === void 0 ? false : _props$capture;

  var _useContext2 = useContext(LocaleContext),
      formatMessage = _useContext2.formatMessage;

  var _useState = useState(isMobileAgent()),
      _useState2 = _slicedToArray(_useState, 1),
      isMobile = _useState2[0];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      files = _useState4[0],
      setFiles = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      masks = _useState6[0],
      setMasks = _useState6[1];

  var _useBreakpoint = useBreakpoint(),
      md = _useBreakpoint.md;

  var mapFilesFromValue = function mapFilesFromValue(urls) {
    var _files = [];
    Promise.all(urls.map( /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(url, index) {
        var type;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getFileType(url);

              case 2:
                type = _context3.sent;

                _files.push({
                  url: url,
                  dataUrl: url,
                  status: 'success',
                  type: type,
                  name: "File".concat(index + 1),
                  size: 0,
                  uid: index
                });

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }())).then(function () {
      return setFiles(_files);
    });
  }; // 有初始值的处理 (不是初始化)


  useEffect(function () {
    if (Array.isArray(value) && value.length && files.length === 0) {
      mapFilesFromValue(value);
    }
  }, [value]);
  useEffect(function () {
    if (!value && !files.length) return;

    if (files.length) {
      var urls = files.map(function (f) {
        var status = f.status,
            name = f.name,
            errorMsg = f.errorMsg;

        if (status === 'failed') {
          return {
            name: name,
            errorMsg: errorMsg
          };
        }

        if (f.url || f.dataUrl) {
          return f.url || f.dataUrl;
        }
      });
      onChange && onChange(urls);
    } else {
      onChange && onChange([]);
    }
  }, [files]);
  var uploadId = useMemo(function () {
    return "igloo-upload-photo-input-".concat(Math.random());
  }, []);
  var uploadIndex = useRef((value === null || value === void 0 ? void 0 : value.length) ? value.length : 0);
  useEffect(function () {
    return function () {
      dataUrlRef.current.forEach(function (dataUrl) {
        URL.revokeObjectURL(dataUrl);
      });
    };
  }, []);
  useEffect(function () {
    var removeLimitMsg = function removeLimitMsg(e) {
      if (DomRef.current && !DomRef.current.contains(e.target) && limitNumError.current) {
        limitNumError.current = undefined;

        if (files && files.length) {
          validateField && validateField();
          return;
        }

        typeof setFieldError === 'function' && setFieldError('');
      }
    };

    window.addEventListener('click', removeLimitMsg);
    return function () {
      window.removeEventListener('click', removeLimitMsg);
    };
  }, [files]);
  useEffect(function () {
    if (limitNumError.current) {
      setFieldError && setFieldError(limitNumError.current);
      return;
    }
  });

  var _useMemo = useMemo(function () {
    if (!md) {
      return {
        sampleSpan: 12,
        descriptionSpan: (2 - samples.length % 2) * 12
      };
    }

    var lastRow = samples.length % 4;
    return {
      sampleSpan: 6,
      descriptionSpan: lastRow > 2 ? 24 : (4 - lastRow) * 6
    };
  }, [!md]),
      sampleSpan = _useMemo.sampleSpan,
      descriptionSpan = _useMemo.descriptionSpan;

  invariant(limit === undefined || limit > 0, "\"limit\" should be a pasitive number.");

  var onUpload = function onUpload(e) {
    if (!e.target.files || !e.target.files.length) return;
    var index = 1;

    var _iterator = _createForOfIteratorHelper(e.target.files),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var file = _step.value;
        uploadFile(file, files.length + index++);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };

  var uploadFile = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(file, currentIndex) {
      var uid, dataUrl, name, size, mimeType, type, errorMsg, _errorMsg;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              uid = ++uploadIndex.current;
              dataUrl = URL.createObjectURL(file);
              dataUrlRef.current.push(dataUrl);
              name = file.name, size = file.size, mimeType = file.type;
              type = classifyType(mimeType);

              if (!(type === 'unknown')) {
                _context4.next = 10;
                break;
              }

              errorMsg = formatMessage({
                id: 'The file type is not supported.'
              });
              limitNumError.current = errorMsg;
              setFieldError && setFieldError(errorMsg);
              return _context4.abrupt("return", Promise.reject(errorMsg));

            case 10:
              if (!(limit && currentIndex > limit)) {
                _context4.next = 15;
                break;
              }

              _errorMsg = (typeof limitErrorMessage === 'function' ? limitErrorMessage(value) : limitErrorMessage) || formatMessage({
                id: 'Quantity of files should be less than {limit}',
                values: {
                  limit: limit
                }
              });
              limitNumError.current = _errorMsg;
              setFieldError && setFieldError(_errorMsg);
              return _context4.abrupt("return", Promise.reject(_errorMsg));

            case 15:
              limitNumError.current = undefined;
              setFiles(function (files) {
                return [].concat(_toConsumableArray(files), [{
                  name: name,
                  type: type,
                  size: size,
                  dataUrl: dataUrl,
                  status: 'progress',
                  originFile: file,
                  uid: uid
                }]);
              });
              return _context4.abrupt("return", handleUploadPromise(file, function (url) {
                return setFiles(function (files) {
                  return files.map(function (f) {
                    if (f.uid === uid) {
                      return _objectSpread(_objectSpread({}, f), {}, {
                        url: url,
                        status: 'success'
                      });
                    }

                    return f;
                  });
                });
              }, function (errorMsg) {
                return setFiles(function (files) {
                  return files.map(function (f) {
                    if (f.uid === uid) {
                      return _objectSpread(_objectSpread({}, f), {}, {
                        status: 'failed',
                        errorMsg: errorMsg
                      });
                    }

                    return f;
                  });
                });
              }));

            case 18:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function uploadFile(_x5, _x6) {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleUploadPromise = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(file, onSuccess, onFailed) {
      var rst, errorMsg;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return handleUpload(file);

            case 3:
              rst = _context5.sent;
              onSuccess(rst);
              return _context5.abrupt("return", Promise.resolve(rst));

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](0);
              errorMsg = _typeof(_context5.t0) === 'object' ? _context5.t0.message : _context5.t0;
              onFailed(errorMsg);
              return _context5.abrupt("return", Promise.reject(errorMsg));

            case 13:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[0, 8]]);
    }));

    return function handleUploadPromise(_x7, _x8, _x9) {
      return _ref5.apply(this, arguments);
    };
  }();

  var handleDelete = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(index) {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              limitNumError.current = null;
              _context6.next = 3;
              return setFiles(function (files) {
                var newArr = files.filter(function (_, i) {
                  return i !== index;
                });
                return newArr;
              });

            case 3:
              _context6.next = 5;
              return setMasks(function (masks) {
                return masks.filter(function (_, i) {
                  return i !== index;
                });
              });

            case 5:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function handleDelete(_x10) {
      return _ref6.apply(this, arguments);
    };
  }();

  var handleReUpload = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(index) {
      var _files$index, originFile, reUpUid, rst;

      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _files$index = files[index], originFile = _files$index.originFile, reUpUid = _files$index.uid;

              if (originFile) {
                _context7.next = 3;
                break;
              }

              return _context7.abrupt("return");

            case 3:
              _context7.next = 5;
              return setFiles(function (files) {
                var newFiles = _toConsumableArray(files);

                newFiles[index].status = 'progress';
                return newFiles;
              });

            case 5:
              _context7.prev = 5;
              _context7.next = 8;
              return handleUpload(originFile);

            case 8:
              rst = _context7.sent;
              _context7.next = 11;
              return setFiles(function (files) {
                var newFiles = _toConsumableArray(files);

                newFiles[index].url = rst;
                newFiles[index].status = 'success';
                return newFiles;
              });

            case 11:
              _context7.next = 17;
              break;

            case 13:
              _context7.prev = 13;
              _context7.t0 = _context7["catch"](5);
              _context7.next = 17;
              return setFiles(function (files) {
                var newFiles = _toConsumableArray(files);

                newFiles[index].status = 'failed';
                newFiles[index].errorMsg = _context7.t0;
                return newFiles;
              });

            case 17:
              if (isMobile) {
                closeMask(index);
              }

            case 18:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[5, 13]]);
    }));

    return function handleReUpload(_x11) {
      return _ref7.apply(this, arguments);
    };
  }();

  var handlePreview = function handlePreview(index) {
    var _files$index2 = files[index],
        dataUrl = _files$index2.dataUrl,
        name = _files$index2.name,
        type = _files$index2.type;
    Modal.noFooter({
      content: _jsx(Preview, {
        src: dataUrl,
        type: classifyType(type)
      }),
      title: name,
      className: 'igloo-upload-photo-preview-modal',
      maskClosable: true,
      closable: true
    });

    if (isMobile) {
      closeMask(index);
    }
  };

  var handleMouseEnter = function handleMouseEnter(index) {
    if (isMobile) return;
    openMask(index);
  };

  var handleMouseLeave = function handleMouseLeave(index) {
    if (isMobile) return;
    closeMask(index);
  };

  var handleTouchEnd = function handleTouchEnd(index) {
    if (!isMobile) return;
    openMask(index);
  };

  var closeMask = function closeMask(index) {
    setMasks(function (masks) {
      var arr = Array.from(masks);
      arr[index] = false;
      return arr;
    });
  };

  var openMask = function openMask(index) {
    setMasks(function (masks) {
      var arr = Array.from(masks);
      arr[index] = true;
      return arr;
    });
  };

  var getBadge = function getBadge(status, index, limit) {
    if (props.disabled) {
      return null;
    }

    if (status === 'progress') {
      return _jsx("div", {
        children: _jsx(LoadingOutlined, {
          spinning: true,
          style: {
            fontSize: 24,
            color: '#999999'
          }
        })
      });
    }

    return _jsx("div", {
      children: _jsx(ErrorFilled, {
        style: {
          color: '#999999',
          cursor: 'pointer',
          fontSize: 24
        },
        onClick: function onClick(e) {
          e.stopPropagation();
          handleDelete(index);
        }
      })
    });
  };

  return _jsxs("div", {
    className: classnames(prefix, className),
    id: id,
    ref: DomRef,
    children: [Boolean(descriptions || samples.length) && _jsx("div", {
      className: "".concat(prefix, "-sample"),
      children: _jsxs(_Row, {
        gutter: [isMobile ? 16 : 32, 16],
        wrap: true,
        children: [Boolean(samples === null || samples === void 0 ? void 0 : samples.length) && samples.map(function (_ref8, index) {
          var _classnames, _classnames2;

          var src = _ref8.src,
              label = _ref8.label,
              type = _ref8.type;
          return _jsxs(_Col, {
            span: sampleSpan,
            children: [_jsx("img", {
              src: src,
              alt: "",
              className: "".concat(prefix, "-sample-photos-photo")
            }), _jsx("div", {
              className: classnames((_classnames = {}, _defineProperty(_classnames, "".concat(prefix, "-sample-photos-good"), type === 'good'), _defineProperty(_classnames, "".concat(prefix, "-sample-photos-bad"), type === 'bad'), _classnames))
            }), label && _jsx("div", {
              className: classnames((_classnames2 = {}, _defineProperty(_classnames2, "".concat(prefix, "-sample-photos-label"), true), _defineProperty(_classnames2, "".concat(prefix, "-sample-photos-label-good"), type === 'good'), _defineProperty(_classnames2, "".concat(prefix, "-sample-photos-label-bad"), type === 'bad'), _classnames2)),
              children: _jsx(IglooTypography, {
                level: "body2",
                children: label
              })
            })]
          }, index);
        }), _jsx(_Col, {
          className: classnames((_classnames3 = {}, _defineProperty(_classnames3, "".concat(prefix, "-sample-descriptions"), true), _defineProperty(_classnames3, "".concat(prefix, "-sample-descriptions-center"), !!md), _classnames3)),
          span: descriptionSpan,
          children: _jsx(IglooTypography, {
            level: "caption2",
            children: descriptions
          })
        })]
      })
    }), _jsx("input", {
      id: uploadId,
      type: "file",
      style: {
        display: 'none'
      },
      onChange: onUpload,
      accept: "image/*,video/*,application/pdf",
      value: [],
      multiple: true,
      capture: capture
    }), _jsxs(_Space, {
      className: "".concat(prefix, "-content"),
      size: [16, 16],
      wrap: true,
      children: [_jsxs("label", {
        htmlFor: uploadId,
        className: classnames((_classnames4 = {}, _defineProperty(_classnames4, "".concat(prefix, "-content-button"), true), _defineProperty(_classnames4, 'dont-show-error-status', Array.isArray(value) && value.some(function (file) {
          return typeof file !== 'string' && (file === null || file === void 0 ? void 0 : file.status) === 'failed';
        })), _classnames4)),
        children: [_jsx(UploadOutlined, {
          style: {
            fontSize: 24,
            color: '#666666'
          }
        }), _jsx("span", {
          style: {
            marginTop: 6
          },
          children: _jsx(IglooTypography, {
            level: "body1",
            children: buttonText || 'Upload'
          })
        })]
      }), files.map(function (_ref9, index) {
        var _classnames5;

        var dataUrl = _ref9.dataUrl,
            status = _ref9.status,
            type = _ref9.type,
            uid = _ref9.uid;
        return _jsx(_Badge, {
          count: getBadge(status, index, limit),
          children: _jsxs("div", {
            className: classnames((_classnames5 = {}, _defineProperty(_classnames5, "".concat(prefix, "-content-container"), true), _defineProperty(_classnames5, "".concat(prefix, "-content-error"), status === 'failed'), _classnames5)),
            onMouseEnter: function onMouseEnter() {
              return handleMouseEnter(index);
            },
            onMouseLeave: function onMouseLeave() {
              return handleMouseLeave(index);
            },
            onClick: function onClick(e) {
              e.stopPropagation();
              handleTouchEnd(index);
            },
            children: [_jsx(MediaItem, {
              type: type,
              src: dataUrl,
              className: "".concat(prefix, "-content-preview")
            }), (!limit || index < limit) && masks[index] && _jsxs(_Fragment, {
              children: [status === 'failed' && _jsx("div", {
                className: "".concat(prefix, "-content-mask"),
                onClick: function onClick(e) {
                  e.stopPropagation();
                  handleReUpload(index);
                },
                children: _jsx(RefreshOutlined, {
                  style: {
                    fontSize: 24
                  }
                })
              }), status === 'success' && _jsx("div", {
                className: "".concat(prefix, "-content-mask"),
                onClick: function onClick(e) {
                  e.stopPropagation();
                  handlePreview(index);
                },
                children: _jsx(ShowOutlined, {
                  style: {
                    fontSize: 24
                  }
                })
              })]
            })]
          })
        }, uid);
      })]
    })]
  });
};

function checkFileList(value) {
  if (!value) {
    return Promise.resolve();
  }

  for (var i = 0; i < value.length; i++) {
    var file = value[i];

    if (_typeof(file) === 'object') {
      var errorMsg = file.errorMsg;
      return Promise.reject(errorMsg);
    }
  }

  return Promise.resolve();
}

UploadPhoto.formItemPropsHandler = function (_ref10) {
  var limit = _ref10.limit,
      previewFormater = _ref10.previewFormater,
      label = _ref10.label;
  return {
    previewFormater: previewFormater || function (value) {
      return _jsx(UploadPreview, {
        files: value,
        label: label
      });
    },
    fullRow: true,
    rules: [{
      validator: function validator(_, value) {
        return checkFileList(value);
      }
    }]
  };
};

export default UploadPhoto;